import type {
  SizeColumnsToContentStrategy,
  SizeColumnsToFitGridStrategy,
} from 'ag-grid-community';
import { useCallback, useEffect, useState } from 'react';

/**
 * The strategy can be generated using {@link GridColumnSizeSettings}
 */
const useAutoSizeStrategy = (
  strategy: FleetOps.ColumnSizeStrategies.Strategy | undefined,
): SizeColumnsToFitGridStrategy | SizeColumnsToContentStrategy | undefined => {
  const buildStrategy = useCallback(():
    | SizeColumnsToFitGridStrategy
    | SizeColumnsToContentStrategy
    | undefined => {
    if (!strategy) {
      return undefined;
    }

    if (strategy.type === 'fitGridWidth') {
      return {
        type: 'fitGridWidth',
        defaultMaxWidth: strategy.defaultMaxWidth,
        defaultMinWidth: strategy.defaultMinWidth,
        columnLimits: strategy.columnLimits.map((l) => ({
          colId: l.field,
          maxWidth: l.maxWidth,
          minWidth: l.minWidth,
        })),
      };
    }

    return {
      type: 'fitCellContents',
      skipHeader: strategy.skipHeader,
      colIds: strategy.fields,
    };
  }, [strategy]);
  const [sizeStrategy, setSizeStrategy] = useState<
    SizeColumnsToFitGridStrategy | SizeColumnsToContentStrategy | undefined
  >(() => buildStrategy());

  useEffect(() => {
    setSizeStrategy(buildStrategy());
  }, [buildStrategy]);

  return sizeStrategy;
};

export default useAutoSizeStrategy;
